import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnexoFicheiroService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // Pegar anexo da campanha (Foto, e Docs PDF )
  getAnexo(id: number): Observable<Blob> {
    return this.apiService.get(`/Anexo/Ficheiro/${id}`, undefined, 'blob');
  }
}
